import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';

import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';
import { rsimProductsUrlParamsAtom } from 'src/atoms/filters/rsim-products';

export const RSimFiltersURLParser = ({ children }: { children: React.ReactNode }) => {
  const [searchParams] = useSearchParams();
  const setFilters = useSetAtom(rsimProductsUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: rsimProductsUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setFilters(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
